import { createNewNotificationContext } from 'src/contexts/NotificationContextBase';

export const GlobalNotificationContext = createNewNotificationContext();
